import styled from 'styled-components';
import { Label } from 'reactstrap';
import { Form } from 'formik';
import { fontStyle } from '@whitelabel/helpers/style/type';
import { spacer, multiply } from '@whitelabel/helpers/style/units';
import FormikFormField from '../../../../FormikFormField';
import Alert from '../../../../Alert';

export const StyledFormikFormField = styled(FormikFormField)`
  margin-bottom: ${multiply(spacer, 1.5)};

  .form-control {
    ${fontStyle('formValue')}
  }

  .invalid-feedback {
    text-align: start;
  }
`;

export const StyledForm = styled(Form)`
  width: 100%;
  text-align: center;
`;

export const StyledLabel = styled(Label)`
  margin-bottom: ${spacer};
  ${fontStyle('formLabel')}
`;

export const StyledAlert = styled(Alert)`
  ${fontStyle('messaging')}
  text-align: start;
`;
